const PHONE_VERIFICATION_ATTEMPT_STORAGE_PREFIX = 'vl_phone_verification_attempt:v1:';

const phoneVerificationUserId = (user) => {
  const value = user?.id || user?.user_id || user?._id;
  return value === undefined || value === null || value === '' ? '' : String(value);
};

const normalizedPhoneDigits = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
  return digits;
};

export const phoneVerificationAttemptStorageKey = (user) => {
  const userId = phoneVerificationUserId(user);
  return userId
    ? `${PHONE_VERIFICATION_ATTEMPT_STORAGE_PREFIX}${encodeURIComponent(userId)}`
    : '';
};

export const readStoredPhoneVerificationAttempt = (user) => {
  const key = phoneVerificationAttemptStorageKey(user);
  if (!key || typeof window === 'undefined') return null;
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(key) || 'null');
    if (
      !stored
      || typeof stored !== 'object'
      || !stored.id
      || !stored.phone_e164
      || !stored.receiving_number
      || !stored.code
    ) {
      return null;
    }
    return stored;
  } catch {
    return null;
  }
};

export const storePhoneVerificationAttempt = (user, attempt) => {
  const key = phoneVerificationAttemptStorageKey(user);
  if (!key || !attempt || typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(key, JSON.stringify(attempt));
  } catch {
    // Verification still works in-memory when storage is unavailable.
  }
};

export const clearStoredPhoneVerificationAttempt = (user) => {
  const key = phoneVerificationAttemptStorageKey(user);
  if (!key || typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // Storage cleanup is best effort.
  }
};

export const confirmedStoredPhoneVerificationAttempt = (storedAttempt, status) => {
  const pending = status?.pending;
  const ttlSeconds = Number(status?.expires_in_seconds);
  const storedCode = String(storedAttempt?.code || '');
  const storedPhone = normalizedPhoneDigits(storedAttempt?.phone_e164);
  const pendingPhone = normalizedPhoneDigits(pending?.phone_e164 || pending?.phone);
  const storedReceiver = normalizedPhoneDigits(storedAttempt?.receiving_number);
  const configuredReceiver = normalizedPhoneDigits(status?.reverse_sms_receiving_number);
  const pendingStatus = String(pending?.status || '');

  if (
    status?.verified
    || !storedAttempt?.id
    || !/^\d{4,8}$/.test(storedCode)
    || !storedReceiver
    || (configuredReceiver && storedReceiver !== configuredReceiver)
    || !pending?.id
    || String(pending.id) !== String(storedAttempt.id)
    || !storedPhone
    || storedPhone !== pendingPhone
    || !['waiting_sms', 'pending'].includes(pendingStatus)
    || !Number.isFinite(ttlSeconds)
    || ttlSeconds <= 0
  ) {
    return null;
  }

  return {
    attempt: {
      ...storedAttempt,
      phone_e164: pending.phone_e164 || pending.phone || storedAttempt.phone_e164,
      submitted_at: pending.submitted_at || storedAttempt.submitted_at,
      expires_at: pending.expires_at || storedAttempt.expires_at,
    },
    ttlSeconds: Math.ceil(ttlSeconds),
  };
};

export const isPhoneVerified = (record) => {
  if (typeof record?.phone_verified === 'boolean') return record.phone_verified;
  if (typeof record?.phoneVerified === 'boolean') return record.phoneVerified;
  return Boolean(record?.phone_verified_at);
};

export const resolvePhoneVerified = (status, user) => {
  if (typeof status?.verified === 'boolean') return status.verified;
  return isPhoneVerified(user);
};
